<main class="main-wrap">
  <div class="left-sidebar-wrapper" *ngIf="deviceType!=='mobile'">
    <app-feeds-company-details-page></app-feeds-company-details-page>
    <!--add for mobile view-->
    <!-- <div class="mobile-btn-wrapper">
      <button class="btn btn-grey-bg">Cancel</button>
    </div> -->
  </div>
  <div class="middle-wrapper">
    <app-feed-details-component></app-feed-details-component>
  </div>
  <div class="right-sidebar-wrapper" *ngIf="deviceType!=='mobile'">
    <app-industry-report-suggestion></app-industry-report-suggestion>
  </div>
</main>
